import { useState, useCallback, useEffect } from 'react';
import { ModifierGroup, Modifier } from 'olo-service/models';
import { useDebounce } from '@clover-util/use-debounce';

type ModifierMap = Record<string, ReadonlyArray<Modifier>>;

export function useModifiersSelectorState(
  onChange?: (modifiers: ReadonlyArray<Modifier>) => void,
  value: ReadonlyArray<Modifier> = []
) {
  const [modifiers, setModifiers] = useState<ModifierMap>(() => value.reduce((map, mod) => {
    // eslint-disable-next-line functional/immutable-data
    if (!map[mod.groupId]) map[mod.groupId] = [];

    // eslint-disable-next-line functional/immutable-data
    map[mod.groupId].push(mod);

    return map;
  }, {} as Record<Uuid, Modifier[]>));

  const onSelectorChange = useCallback(({ id }: ModifierGroup, selectedModifiers: ReadonlyArray<Modifier>) => {
    setModifiers({
      ...modifiers,
      [id]: selectedModifiers
    });
  },[modifiers, setModifiers]);

  const fireOnChangeEvent = useDebounce((updated: ModifierMap) => {
    onChange?.(Object.values(updated).reduce((acc, val) => acc.concat(val), []));
  }, [onChange]);

  useEffect(() => fireOnChangeEvent(modifiers), [fireOnChangeEvent, modifiers]);

  return { modifiers, onSelectorChange };
}
